module.exports = __webpack_public_path__ + "static/media/p5_face2.777994d6.png";